import { render, staticRenderFns } from "./CalliaExcelToPdf.vue?vue&type=template&id=32d5c1ff&scoped=true"
import script from "./CalliaExcelToPdf.vue?vue&type=script&lang=js"
export * from "./CalliaExcelToPdf.vue?vue&type=script&lang=js"
import style0 from "./CalliaExcelToPdf.vue?vue&type=style&index=0&id=32d5c1ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d5c1ff",
  null
  
)

export default component.exports